import { Module } from "vuex";
import { AlarmPointState } from "./types";
import { RootState } from "../types";
import { Region } from "../types";

import api from "@/services/api.service";
import axios from "axios";

export function getDefaultState(): AlarmPointState {
	return {
		displayResponseId: null,
		responses: [],
		alarmPointManagerOpen: false,
		cancelTokenSource: null,
		selectedResponse: null,
		selectedArea: null,
		disableAutomaticLoad: false
	};
}

export const state: AlarmPointState = getDefaultState();

const namespaced: boolean = true;

export const alarmPoints: Module<AlarmPointState, RootState> = {
	namespaced,
	state,
	getters: {
		getDisplayResponseId: apState => apState.displayResponseId,
		getResponses: apState => apState.responses,
		getAlarmPointManagerOpen: apState => apState.alarmPointManagerOpen,
		getCancelTokenSource: apState => apState.cancelTokenSource,
		getSelectedResponse: apState => apState.selectedResponse,
		getSelectedArea: apState => apState.selectedArea,
		getDisableAutomaticLoad: apState => apState.disableAutomaticLoad
	},
	mutations: {
		setDisplayResponseId: (apState, responseId) => {
			apState.displayResponseId = responseId;
		},
		setResponses: (apState, responses: any[]) => (apState.responses = responses),
		setAlarmPointManagerOpen: (apState, open) => {
			apState.alarmPointManagerOpen = open;
		},
		setCancelTokenSource: (apState, cancelToken) => (apState.cancelTokenSource = cancelToken),
		setSelectedResponse: (apState, response) => (apState.selectedResponse = response),
		setSelectedArea: (apState, area) => (apState.selectedArea = area),
		armSelectedArea: apState => {
			apState.selectedArea.armed = true;
			apState.selectedArea.toggleArmAt = null;
			apState.selectedArea.disarmReasonID = null;
		},
		setDisableAutomaticLoad: (apState, data: any) => {
			apState.disableAutomaticLoad = data;
		},
		resetState: apState => {
			Object.assign(apState, getDefaultState());
		}
	},
	actions: {
		async responseSearch({ commit }, { query, regionURL }) {
			const cancelTokenSource = axios.CancelToken.source();

			commit("setCancelTokenSource", cancelTokenSource);
			commit("setResponses", await api.responseSearch(cancelTokenSource.token, query, regionURL));
		},
		async fetchDisableAutomaticLoad({ commit }) {
			const { data } = await api.disableAutomaticLoad();
			commit("setDisableAutomaticLoad", data);
		}
	}
};
